import React, { useEffect, useRef, useState } from "react";
import "./About.css";
import aboutImg from "../assets/activity1.JPG";



// CERTIFICATE IMAGES
import cert1 from "../assets/award-certificate1.jpg";
import cert2 from "../assets/award-certificate2.jpg";
import cert3 from "../assets/award-certificate3.jpg";
import cert4 from "../assets/award-certificate4.jpg";
import cert5 from "../assets/award-certificate5.jpg";
import resultFront from "../assets/result-front.jpeg";
import resultBack from "../assets/result-back.jpeg";


import { FaEye, FaBullseye } from "react-icons/fa";
import { FaSchool, FaUserGraduate, FaBookOpen } from "react-icons/fa";
// AOS
import AOS from "aos";
import "aos/dist/aos.css";

export default function About() {

  // REFRESH AOS
  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <div className="about-page">

      {/* ── ABOUT HERO ── */}
      <div className="about-hero">

        {/* LEFT */}
        <div className="about-left" data-aos="fade-right">
          <h2>About Lotus Lap Public School</h2>

          <h3 className="about-tagline">
            Where Every Child’s Potential Awakens and Blossoms
          </h3>

          <p>
            Lotus Lap Public School is more than just an institution it is the
            first step in a child’s journey beyond home, where curiosity is
            nurtured and learning becomes a natural process.
          </p>

          <p>
            At Lotus Lap, education goes beyond textbooks. We focus on
            awakening the extraordinary potential present in every child,
            helping them grow academically, emotionally, and socially.
          </p>

          <p>
            Our goal is to nurture confident thinkers, responsible individuals,
            and lifelong learners who are in harmony with themselves and the
            world around them.
          </p>

          <div className="about-signature" data-aos="fade-up" data-aos-delay="200">
            “Changing Lives Through Education & Making Dreams Come True”
          </div>
        </div>

        {/* RIGHT */}
        <div className="about-visual" data-aos="fade-left">
          <div className="about-img-wrap">
            <img src={aboutImg} alt="Students" />
          </div>
        </div>

      </div>

      {/* ── VISION & MISSION ── */}
      <div className="vision-mission">

        <div className="vm-card vision" data-aos="zoom-in">
          <div className="vm-icon">
            <FaEye />
          </div>
          <h2>Our Vision</h2>
          <p>
            To create an environment that nurtures young minds and helps them
            discover their true potential. Lotus Lap Public School envisions
            shaping students into confident, responsible, and well rounded
            individuals who contribute positively to society.
          </p>
        </div>

        <div
          className="vm-card mission"
          data-aos="zoom-in"
          data-aos-delay="150"
        >
          <div className="vm-icon">
            <FaBullseye />
          </div>
          <h2>Our Mission</h2>
          <p>
            Our mission is to provide quality education beyond academics,
            focusing on holistic development. We aim to foster creativity,
            critical thinking, discipline, and strong values in every student.
          </p>
        </div>
    
      </div>
      {/* ── LEADERSHIP SECTION ── */}
<LeadershipSection />

      {/* ── STATS ── */}
      <StatsSection />

      {/* ── ACHIEVEMENTS ── */}
      <AchievementsSection />

        {/* ✅ ADD HERE */}
    <HighlightsSection />

    </div>
  );
}


/* ─────────────────────────────
   COUNTER COMPONENT
───────────────────────────── */
function Counter({ end, duration = 2000 }) {
  const [count, setCount] = useState(0);
  const ref = useRef();
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;

          let startTime = null;

          const animate = (time) => {
            if (!startTime) startTime = time;
            const progress = time - startTime;
            const progressRatio = Math.min(progress / duration, 1);

            const value = Math.floor(progressRatio * end);
            setCount(value);

            if (progress < duration) {
              requestAnimationFrame(animate);
            } else {
              setCount(end);
            }
          };

          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [end, duration]);

  return <h2 ref={ref}>{count}+</h2>;
}


/* ─────────────────────────────
   STATS SECTION
───────────────────────────── */
function StatsSection() {
  return (
    <div className="stats-section">

      <div className="stat-box" data-aos="fade-up">
        <Counter end={10000} />
        <p>Happy Students</p>
      </div>

      <div className="stat-box" data-aos="fade-up" data-aos-delay="100">
        <Counter end={150} />
        <p>Professional Staff</p>
      </div>

      <div className="stat-box" data-aos="fade-up" data-aos-delay="200">
        <Counter end={20} />
        <p>School Activities</p>
      </div>

      <div className="stat-box" data-aos="fade-up" data-aos-delay="300">
        <Counter end={26} />
        <p>Years of Experience</p>
      </div>

    </div>
  );
}


function AchievementsSection() {
  const images = [cert1, cert2, cert3, cert4, cert5, resultFront, resultBack];

  const [index, setIndex] = useState(1);
  useEffect(() => {
  setIndex(0); // ✅ always start from first card
}, []);

  // ✅ AUTO SCROLL (ONLY FOR MOBILE/TABLET)
  useEffect(() => {
    const isMobile = window.innerWidth <= 1024;

    if (!isMobile) return; // desktop untouched

    const interval = setInterval(() => {
      setIndex((prev) => {
        if (prev >= images.length - 1) return 0;
        return prev + 1;
      });
    }, 2500); // speed

    return () => clearInterval(interval);
  }, [images.length]);

  const nextSlide = () => {
    if (index < images.length - 1) {
      setIndex(index + 1);
    }
  };

  const prevSlide = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  return (
    <div className="achievements-section">

      {/* HEADER */}
      <div className="achievements-header" data-aos="fade-up">
        <h2>Our Achievements</h2>
        <h4>Celebrating Excellence & Milestones</h4>
      </div>

      <div className="netflix-carousel">

        {/* LEFT (hidden in mobile via CSS) */}
        <button className="arrow left" onClick={prevSlide}>‹</button>

        <div className="netflix-track">
          {images.map((img, i) => {
            const position = i - index;

            if (position < -1 || position > 1) return null;

            return (
              <div
                key={i}
                className={`netflix-card 
                  ${position === 0 ? "active" : ""}
                  ${position !== 0 ? "side" : ""}
                `}
              >
                <img src={img} alt="" />
              </div>
            );
          })}
        </div>

        {/* RIGHT (hidden in mobile via CSS) */}
        <button className="arrow right" onClick={nextSlide}>›</button>

      </div>

    </div>
  );
}

function HighlightsSection() {

  return (
    <div className="highlights-section">

      {/* ── SECTION HEADER ── */}
      <div className="highlights-header" data-aos="fade-up">
        <h2>
          A Friendly School Having Pride in Their Students
        </h2>
        <p>Everyday Care for Your Children</p>
      </div>

      {/* ── CARDS ── */}
      <div className="highlights-grid">

        <div className="highlight-card" data-aos="fade-up">
          <FaSchool className="highlight-icon blue" />
          <h3>Safe & Inspiring Campus</h3>
          <p>
            A secure and joyful environment where children feel comfortable,
            confident, and ready to learn every day.
          </p>
        </div>

        <div
          className="highlight-card active"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          <FaUserGraduate className="highlight-icon green" />
          <h3>Expert Guidance</h3>
          <p>
            Dedicated educators who nurture every child’s potential and
            encourage independent thinking.
          </p>
        </div>

        <div
          className="highlight-card"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <FaBookOpen className="highlight-icon orange" />
          <h3>Balanced Learning</h3>
          <p>
            A blend of academics and activities that builds confidence,
            creativity, and strong values.
          </p>
        </div>

      </div>
    </div>
  );
}
function LeadershipSection() {
  const leaders = [
    {
      name: "Dr. Sri Kadari Chandrashekar Reddy",
      role: "Founder, Lotus Lap Public School",
      img: require("../assets/founder.jpeg"),
      msg: `Dr. Sri Kadari Chandra Shekhar Reddy, a renowned educationist, entrepreneur, and social reformer, was conferred the prestigious "Honorary Doctorate Award - 2025" by Dayspring Theological University, Dallas, Texas, USA. The award was presented by Dr. M Varaprasad Garu, Chairman & Founder of GSHSTA, on June 4, 2025, at the Surya Loka Complex in Hyderabad.
This esteemed recognition honors Sri Reddy's outstanding contributions to education and social services. As the Founder Chairman of Lotus Lap Public Schools, he has empowered over 10,000 students across different branches. His commitment to inclusive education is reflected in the extensive support offered to underprivileged children.
Sri Chandra Shekar Reddy's initiatives extend beyond education, including social innovation, agriculture-based experiential learning, and legal advocacy. He serves in various key roles, such as CEO of Vidvas Kids Schools and Managing Director of Amruthavanam Agri Farm School & Agrifarm Resorts.
The award ceremony was attended by eminent celebrities, who felicitated Sri Chandra Shekar Reddy for his remarkable achievements. His dedication to community upliftment and holistic leadership has earned him national recognition, including World Amazing Records and India Book of Records.
This honor is a testament to Sri Kadari Chandra Shekhar Reddy's tireless efforts in bridging education, social service, sustainable development, and entrepreneurship.`
    },

    {
      name: "Smt Kadari Madhavi",
      role: "Director, Lotus Lap Public School",
      img: require("../assets/md.jpeg"),
      msg: `Smt Kadari Madhavi is a dedicated and visionary leader serving as Director of Lotus Lap Public School, where she plays a pivotal role in shaping the institution’s financial and administrative foundation.
With a keen eye for detail and a strong commitment to transparency, she oversees all financial planning, budgeting, fee structures, audits, and resource allocation, ensuring that every rupee invested directly contributes to enhancing the quality of education and infrastructure for students.
As the finance-in-charge, Kadari Madhavi ensures disciplined and strategic financial management, aligning school expenditures with long-term academic goals and value-based education. She works closely with the management and academic team to support initiatives such as infrastructure development, teacher training, student welfare schemes, and technology upgrades, all while maintaining strict compliance and accountability.
Kadari Madhavi is known for her calm yet decisive leadership, combining practical financial acumen with a deep sense of responsibility towards the school community. She believes that sound financial planning is not just about numbers, but about creating a stable and nurturing environment in which teachers and students can thrive without unnecessary constraints.
Her approach reflects transparency, integrity, and a genuine commitment to service, making her an integral pillar of Lotus Lap Public School’s sustainable growth.`
    },

    {
      name: "Dr. Padmaja Reddy",
      role: "Academic Advisor",
      img: require("../assets/academic-counc.jpeg"),
      msg: `Dr. Padmaja Reddy is a distinguished academic leader and visionary educator, honored with an Honorary Doctorate in 2025 by Dayspring Theological University, Dallas, Texas, USA for her outstanding contributions to education.
With an M.Sc. and M.Ed., she has served in key roles across India’s leading institutions—beginning as a Mathematics IIT faculty with Sri Chaitanya Group of Schools, later leading as Principal at Lotus Lap Group of Schools in Hyderabad, and further serving as Principal for Narayana Group of Schools in the Delhi NCR region.
She also contributed as HR Head for the North Zone, strengthening faculty development and organizational growth. Under her guidance, students achieved remarkable success, including state-level CBSE ranks of 6th and 10th.
Beyond academics, Dr. Reddy has completed her Tapas in Art of Living from Ekam Oneness Organisation and introduced meditation sessions at Lotus Lap Schools, fostering holistic well-being among students and staff. She actively trains principals and faculty.`
    },

    {
      name: "Mrs. Swapna Dubli",
      role: "Principal - Kothapet Branch",
      img: require("../assets/saroornagar-principal.jpeg"),
      msg: `Mrs. Swapna Dubli is a dedicated and visionary educator serving as the Principal of Lotus Lap School, Kothapet Branch.
She is committed to fostering a nurturing and dynamic learning environment, with a strong passion for academic excellence and holistic development. She has been instrumental in shaping young minds and guiding them towards a bright and successful future.
With extensive experience in the field of education, she has been recognized for her excellence in teaching and leadership, having been awarded Best Teacher and Best Academic Coordinator.
She believes in creating a student-centered learning atmosphere that encourages curiosity, creativity, and critical thinking. Her leadership focuses on maintaining high academic standards while also promoting values, discipline, and essential life skills among students.
She strongly advocates a collaborative approach involving teachers, parents, and the community to ensure the overall development of every child. Under her guidance, the institution continues to strive for excellence in academics, co-curricular activities, and character building.
Her vision is to empower students to become confident, responsible, and compassionate individuals who contribute positively to society.`
    },

    {
      name: "Mrs. Mamatha",
      role: "Principal - Karmanghat",
      img: require("../assets/karmanghat-princ.jpeg"),
      msg: `A Visionary Leader and Innovative Educator
 Mrs. Mamatha holds an M.Sc. and B.Ed., building a strong foundation in science and education.She began her career as a Degree College Lecturer and quickly rose to leadership roles, now serving as a dynamic Principal.
She believes in “learning by doing,” focusing on practical understanding over rote learning. Fluent in five languages, she connects effectively with students and staff.
An all-rounder, she has won university-level prizes in Throwball and Kabaddi and earned recognition in dance competitions.
In 2025, she received the Best Innovative Principal Award at Ravindra Bharathi.
Her leadership reflects courage, creativity, and a constant drive for excellence.`
    },
    {
      name: "Mrs. Anitha",
      role: "School In-Charge",
      img: require("../assets/anitha.jpeg"),
      msg: `Mrs. Anitha serves as the School In-Charge at Lotus Lap Public School, bringing dedication, leadership, and a passion for education to her role.
She is also a Mathematics educator for primary students, helping young learners build strong foundational skills and develop confidence in the subject.
With her student-centered approach and commitment to academic excellence, she strives to create a positive learning environment that supports the holistic growth and success of every child.`
    },
    {
      name: "Mr. Nandikonda Ravindra Reddy",
      role: "School Manager",
      img: require("../assets/manager.jpeg"),
      msg: `Mr. Nandikonda Ravindra Reddy serves as the School Coordinator at Lotus Lap Public School and is a dedicated Telugu Faculty member for high school students.
With his strong leadership and organizational skills, he plays a vital role in coordinating academic activities and ensuring the smooth functioning of the school.
As an impactful motivational speaker and trainer, he inspires students to develop confidence, discipline, and a positive outlook towards learning and life.
His commitment to education and student success makes him a valued mentor and guide within the school community.`
    }
  ];

  return (
    <div className="leadership-section">

      <div className="leadership-header" data-aos="fade-up">
        <h2>Our Leadership</h2>
        <p>Guiding Visionaries Behind Our Success</p>
      </div>

      {leaders.map((leader, i) => (
        <div className="leader-block" key={i} data-aos="fade-up">

          <h2 className="leader-name">{leader.name}</h2>
          <h4 className="leader-role">{leader.role}</h4>

          <p className="leader-text">
            {leader.msg.split("\n").map((line, index) => (
              <span key={index}>
                {line}
                <br /><br />
              </span>
            ))}
          </p>

          <div className="leader-image">
            <img src={leader.img} alt={leader.name} />
          </div>

        </div>
      ))}

    </div>
  );
}